import { Currency } from '../models/moneyModel'

export type WithCurrency = { currency?: Currency }
export type WithDebtorId = { debtorId?: string }

export const validateSameCurrency = <T extends WithCurrency>(
    selection: T[],
    message: string
): { isValid: true } | { isValid: false; reason: string } => {
    if (selection.length <= 1) {
        return { isValid: true }
    }

    const hasDifferentCurrencies = selection.some((item) => item.currency !== selection[0].currency)

    if (hasDifferentCurrencies) {
        return {
            isValid: false,
            reason: message
        }
    }

    return { isValid: true }
}

export const validateSameDebtorId = <T extends WithDebtorId>(
    selection: T[],
    message: string
): { isValid: true } | { isValid: false; reason: string } => {
    if (selection.length <= 1) {
        return { isValid: true }
    }

    const hasDifferentDebtorIds = !selection.every((item) => item.debtorId === selection[0].debtorId)

    if (hasDifferentDebtorIds) {
        return {
            isValid: false,
            reason: message
        }
    }

    return { isValid: true }
}
